import { StyleSheet } from 'react-native';

import type { useTheme } from '../theme';

// Rest-default picker modal (Track R — split from loggerStyles.ts; pure data,
// merged by the loggerStyles barrel). Not imported directly. The rest/hold
// timer banner itself moved to @heraion/ui's <TimerBanner> in Fase 2.
export function restStyles(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    // Rest-default picker Modal (replaces the 1.81.0 Alert preset list).
    // Centered card on a translucent backdrop; the value is picked with a
    // RestStepper (−/+ and preset chips), not a native slider.
    restPickerBackdrop: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.55)',
      alignItems: 'center',
      justifyContent: 'center',
      padding: s.s4,
    },
    restPickerCard: {
      width: '100%',
      maxWidth: 420,
      backgroundColor: p.surface,
      borderRadius: r.r3,
      borderWidth: 1,
      borderColor: p.border,
      padding: s.s4,
      gap: s.s3,
    },
    restPickerTitle: {
      color: p.ink,
      fontSize: t.sizes.lg,
      fontWeight: '700',
    },
    restPickerBody: {
      color: p.ink2,
      fontSize: t.sizes.sm,
    },
    restPickerActions: {
      flexDirection: 'row',
      gap: s.s2,
      marginTop: s.s2,
    },
    restPickerGlobalRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s.s2,
      paddingVertical: s.s2,
      paddingHorizontal: s.s2,
      marginTop: s.s2,
      borderRadius: r.r2,
      borderWidth: 1,
      borderColor: p.border,
      backgroundColor: p.surface2,
      minHeight: 44,
    },
    restPickerGlobalLabel: {
      color: p.ink,
      fontSize: t.sizes.sm,
      flexShrink: 1,
    },
    // Inlined from the retired <Checkbox> primitive (1 real callsite) —
    // display-only box + check icon; the Pressable above owns the tap
    // target + a11y checkbox role.
    restCheckbox: {
      width: 22,
      height: 22,
      borderRadius: r.r2,
      borderWidth: 2,
      borderColor: p.borderStrong,
      backgroundColor: p.surface,
      alignItems: 'center',
      justifyContent: 'center',
    },
    restCheckboxChecked: {
      backgroundColor: p.brand500,
      borderColor: p.brand500,
    },
    restPickerActionButton: {
      flex: 1,
      minHeight: 40,
      paddingHorizontal: s.s3,
      borderRadius: r.r2,
      borderWidth: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    restPickerActionCancel: {
      borderColor: p.border,
      backgroundColor: p.surface2,
    },
    restPickerActionSave: {
      borderColor: p.brand500,
      backgroundColor: p.brand500,
    },
    restPickerActionLocked: {
      opacity: 0.5,
    },
    restPickerActionPressed: {
      opacity: 0.7,
    },
    restPickerActionTextCancel: {
      color: p.ink2,
      fontSize: t.sizes.base,
      fontWeight: '700',
    },
    restPickerActionTextSave: {
      color: p.inkOnBrand,
      fontSize: t.sizes.base,
      fontWeight: '700',
    },
    cancel: {
      color: p.ink2,
      fontSize: t.sizes.base,
    },
    save: {
      color: p.brand500,
      fontSize: t.sizes.base,
      fontWeight: '600',
    },
    actionDisabled: {
      opacity: 0.4,
    },
  });
}
